import React, { useState, useEffect, useRef } from "react";
import { NavLink } from "react-router-dom";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";
import * as XlsxPopulate from "xlsx-populate/browser/xlsx-populate";
import { toast } from "react-toastify";
import { API_URL } from "../../../config";
import exportIcon from "../../../assets/image/document-download.png";

import {
  Row,
  Col,
  Container,
  Input,
  FormGroup,
  Table,
  Nav,
  ModalFooter,
  ModalHeader,
  ModalBody,
  Modal,
} from "reactstrap";
import Switch from "react-switch";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Navigate, useNavigate } from "react-router-dom";

import axios from "axios";
import Dropdown from "../../layouts/dropdown/Dropdown";

function Activity() {
  let navigate = useNavigate();
  let [checked, setChecked] = useState(false);

  const [searchStatus, setSearchStatus] = useState("");
  let [isChecked, setIsChecked] = useState(false);
  const [startDate, setStartDate] = useState(null);

  const [search, setSearch] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [show, setShow] = useState(false);

  const [showDropdown, setShowDropdown] = useState(false);
  const [format, setFormat] = useState("pdf");
  const [period, setPeriod] = useState("Monthly");
  const dateDropdownRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const [isOpen1, setIsOpen1] = useState(false);
  const [selected, setSelected] = useState("All Users");
  const [selectedRange, setSelectedRange] = useState("");
  const dropdownRef = useRef(null);
  const [showSearch, setShowSearch] = useState(false);
  const dropdownRef2 = useRef(null);
  const [showDropdown1, setShowDropdown1] = useState(false);
  const toggleDropdown1 = () => {
    setShowDropdown1((prev) => !prev);
  };


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef2.current &&
        !dropdownRef2.current.contains(event.target)
      ) {
        setShowDropdown1(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }

    if (isOpen1) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen1]);

  const [selectedItems, setSelectedItems] = useState([]);
  const [selectedItems1, setSelectedItems1] = useState([]);
  const [search1, setSearch1] = useState("");
  const [companies, setCompanies] = useState([]);
  const [branches, setBranches] = useState([]);

  useEffect(() => {
    const fetchBranches = async () => {
      try {
        const res = await axios.get(`${API_URL}/auditor/branch/getAllBranch`);
        const branchNames = res.data.data.map((branch) => branch.branch_id);
        setBranches(branchNames);
      } catch (error) {
        console.error("Error fetching branches:", error);
      }
    };

    fetchBranches();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dateDropdownRef.current &&
        !dateDropdownRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const fetchCompanies = async () => {
      try {
        const res = await axios.get(`${API_URL}/auditor/company/companies`);
        setCompanies(res.data.data.map((c) => c.company_name));
      } catch (err) {
        console.error("Error fetching companies:", err);
      }
    };

    fetchCompanies();
  }, []);

  const [endDate, setEndDate] = useState(null);

  const toggleSelection = (company) => {
    setSelectedItems((prev) =>
      prev.includes(company)
        ? prev.filter((c) => c !== company)
        : [...prev, company]
    );
  };

  const toggleSelection1 = (item) => {
    setSelectedItems1((prev) =>
      prev.includes(item) ? prev.filter((i) => i !== item) : [...prev, item]
    );
  };

  const toggleDropdown = () => setShowDropdown(!showDropdown);
  const [logs, setLogs] = useState([]); // paginated data
  const [allLogs, setAllLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);

  const [filteredLogs, setFilteredLogs] = useState([]);
  const [limit] = useState(10);

  const handleApplyDateFilter = () => {
    // Date filter is automatically applied via useEffect when startDate/endDate change
    // This function just closes the calendar
    if (startDate && endDate) {
      setSelectedRange("Manual");
    }
    setIsOpen(false); // close calendar after apply
  };

  // Fetch logs (all)
  const fetchLogs = async () => {
    try {
      const response = await axios.get(`${API_URL}/activity/all`);
      setAllLogs(response.data.data);
      setLogs(response.data.data.slice(0, limit)); // default page 1
    } catch (err) {
      console.error("Error fetching logs:", err);
      setError("Failed to load activity logs.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const searchLower = searchQuery.toLowerCase();

    if (!searchLower.trim()) {
      setLogs(allLogs.slice(0, limit)); // show paginated logs
    } else {
      const filtered = allLogs.filter(
        (log) =>
          (log.company_name?.toLowerCase().includes(searchLower) ?? false) ||
          (log.branch?.toLowerCase().includes(searchLower) ?? false) ||
          (log.user?.toLowerCase().includes(searchLower) ?? false) ||
          (log.latest_activity?.toLowerCase().includes(searchLower) ?? false)
      );

      setLogs(filtered);
    }
  }, [searchQuery, allLogs]);

  // Pagination
  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  // Export Handler
  const handleExport = () => {
    const filteredLogs = filterLogsByPeriod(allLogs, period); // ✅ use allLogs here

    if (format === "pdf") {
      exportToPDF(filteredLogs);
    } else if (format === "excel") {
      exportToExcel(filteredLogs);
    }

    setShowDropdown(false);
  };

  // Period Filter
  const filterLogsByPeriod = (data, period) => {
    const now = new Date();
    let fromDate = new Date();

    switch (period) {
      case "Monthly":
        fromDate.setMonth(now.getMonth() - 1);
        break;
      case "Quarterly":
        fromDate.setMonth(now.getMonth() - 3);
        break;
      case "Semi-Annually":
        fromDate.setMonth(now.getMonth() - 6);
        break;
      case "Annually":
        fromDate.setFullYear(now.getFullYear() - 1);
        break;
      default:
        return data;
    }

    return data.filter((log) => new Date(log.created_at) >= fromDate);
  };

  // Export PDF
  const exportToPDF = (data) => {
    const doc = new jsPDF();
    autoTable(doc, {
      head: [
        [
          "Sr No",
          "Company",
          "Branch",
          "IP",
          "User Type",
          "User",
          "Activity",
          "Date",
        ],
      ],
      body: data.map((log, i) => [
        i + 1,
        log.company_name,
        log.branch,
        log.ip_address,
        log.user_type,
        log.user,
        log.latest_activity,
        new Date(log.created_at).toLocaleString(),
      ]),
      startY: 20,
    });

    doc.text("Activity Logs", 14, 15);
    doc.save(`activity_${period}.pdf`);
  };

  // Export Excel
  const exportToExcel = (data) => {
    const formattedData = data.map((log, i) => ({
      "Sr No": i + 1,
      Company: log.company_name,
      Branch: log.branch,
      IP: log.ip_address,
      "User Type": log.user_type,
      User: log.user,
      Activity: log.latest_activity,
      Date: new Date(log.created_at).toLocaleString(),
    }));

    const displayHeaders = Object.keys(formattedData[0] || {});

    const uniqueCompanies = [
      ...new Set(formattedData.map((item) => item.Company).filter(Boolean)),
    ];
    let companyNameText = "";
    if (uniqueCompanies.length > 0) {
      companyNameText = uniqueCompanies.join(", ");
    } else {
      companyNameText = "Company Name";
    }

    const uniqueBranches = [
      ...new Set(formattedData.map((item) => item.Branch).filter(Boolean)),
    ];
    let locationText = "";
    if (uniqueBranches.length > 0) {
      locationText = uniqueBranches.join(", ");
    } else {
      locationText = "All Locations";
    }

    let dateRangeText = period || "All";

    const getColumnLetter = (colIndex) => {
      let temp,
        letter = "";
      while (colIndex > 0) {
        temp = (colIndex - 1) % 26;
        letter = String.fromCharCode(65 + temp) + letter;
        colIndex = (colIndex - temp - 1) / 26;
      }
      return letter;
    };

    const totalCols = displayHeaders.length;
    const lastColLetter = getColumnLetter(totalCols);
    const totalRows = 4 + formattedData.length;

    const worksheet = XLSX.utils.json_to_sheet(formattedData, {
      origin: "A4",
    });

    const colWidths = displayHeaders.map((header) => ({
      wch: Math.max(header.length + 5, 18),
    }));
    worksheet["!cols"] = colWidths;

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Activity Logs");

    const wbout = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

    XlsxPopulate.fromDataAsync(wbout)
      .then((wb) => {
        const sheet = wb.sheet(0);

        // 1. Row 1: Company Name (Left Aligned)
        const companyRange = sheet.range(`A1:${lastColLetter}1`);
        companyRange.merged(true);
        sheet.cell("A1").value(`Company Name: ${companyNameText}`);
        companyRange.style({
          bold: true,
          fontSize: 14,
          wrapText: true,
          horizontalAlignment: "left",
          verticalAlignment: "center",
          fill: "F2F2F2",
          border: true,
        });

        // 2. Row 2: Location (Left Aligned)
        const locationRange = sheet.range(`A2:${lastColLetter}2`);
        locationRange.merged(true);
        sheet.cell("A2").value(`Location: ${locationText}`);
        locationRange.style({
          bold: true,
          fontSize: 11,
          wrapText: true,
          horizontalAlignment: "left",
          verticalAlignment: "center",
          fill: "F2F2F2",
          border: true,
        });

        // 3. Row 3: Period (Left Aligned)
        const dateRange = sheet.range(`A3:${lastColLetter}3`);
        dateRange.merged(true);
        sheet.cell("A3").value(`Period: ${dateRangeText}`);
        dateRange.style({
          bold: true,
          fontSize: 11,
          wrapText: true,
          horizontalAlignment: "left",
          verticalAlignment: "center",
          fill: "F2F2F2",
          border: true,
        });

        // 4. Headings (Row 4): bold, larger text size, text wrapping, highlighted background, borders
        sheet.range(`A4:${lastColLetter}4`).style({
          bold: true,
          fontSize: 12,
          wrapText: true,
          horizontalAlignment: "center",
          verticalAlignment: "center",
          fill: "D9E1F2",
          border: true,
        });

        // 5. Data Contents (Row 5..totalRows): text wrapping, vertical alignment, borders
        if (totalRows >= 5) {
          sheet.range(`A5:${lastColLetter}${totalRows}`).style({
            wrapText: true,
            fontSize: 10,
            verticalAlignment: "center",
            border: true,
          });
        }

        return wb.outputAsync();
      })
      .then((blob) => {
        const url = window.URL.createObjectURL(new Blob([blob]));
        const a = document.createElement("a");
        a.href = url;
        a.download = `activity_${period}.xlsx`;
        a.click();
        window.URL.revokeObjectURL(url);
      });
  };

  const handleQuickSelect = (range) => {
    const today = new Date();
    let start = null;
    let end = null;

    switch (range) {
      case "Today":
        start = new Date(today);
        end = new Date(today);
        start.setHours(0, 0, 0, 0);
        end.setHours(23, 59, 59, 999);
        break;
      case "Yesterday":
        start = new Date(today);
        end = new Date(today);
        start.setDate(today.getDate() - 1);
        end.setDate(today.getDate() - 1);
        start.setHours(0, 0, 0, 0);
        end.setHours(23, 59, 59, 999);
        break;
      case "Last 7 days":
        start = new Date(today);
        start.setDate(today.getDate() - 6); // include today
        end = new Date(today);
        start.setHours(0, 0, 0, 0);
        end.setHours(23, 59, 59, 999);
        break;
      case "Last 30 days":
        start = new Date(today);
        start.setDate(today.getDate() - 29); // include today
        end = new Date(today);
        start.setHours(0, 0, 0, 0);
        end.setHours(23, 59, 59, 999);
        break;
      default:
        break;
    }

    // Set selected range and dates - filter will be applied automatically via useEffect
    setSelectedRange(range);
    setStartDate(start);
    setEndDate(end);
    
    // Filter is automatically applied when startDate/endDate change
    // setIsOpen(false); // close dropdown
  };
  const searchLower = searchQuery?.toLowerCase() || "";
  const dataToRender = (filteredLogs.length > 0 ? filteredLogs : [])
    .filter((log) => selected === "All Users" || log.user_type === selected)
    .filter(
      (log) =>
        selectedItems1.length === 0 || selectedItems1.includes(log.branch)
    )
    .filter(
      (log) =>
        !searchLower.trim() ||
        (log.company_name?.toLowerCase().includes(searchLower) ?? false) ||
        (log.branch?.toLowerCase().includes(searchLower) ?? false) ||
        (log.user?.toLowerCase().includes(searchLower) ?? false) ||
        (log.latest_activity?.toLowerCase().includes(searchLower) ?? false)
    );

  const paginatedData = dataToRender.slice(
    (currentPage - 1) * limit,
    currentPage * limit
  );
  const totalPages = Math.ceil(dataToRender.length / limit);

  // const paginatedData = dataToRender.slice(
  //   (currentPage - 1) * limit,
  //   currentPage * limit
  // );
  // const totalPages = Math.ceil(dataToRender.length / limit);

  useEffect(() => {
    fetchLogs();
  }, []);
  useEffect(() => {
    let filtered = [...allLogs]; // Start with all logs

    // ✅ Company name filter - combine with existing filters
    if (selectedItems.length > 0) {
      filtered = filtered.filter((log) =>
        selectedItems.includes(log.company_name)
      );
    }

    // ✅ User type filter - combine with existing filters
    if (selected !== "All Users") {
      filtered = filtered.filter((log) => log.user_type === selected);
    }

    // ✅ Branch filter - combine with existing filters
    if (selectedItems1.length > 0) {
      filtered = filtered.filter((log) =>
        selectedItems1.includes(log.branch)
      );
    }

    // ✅ Date range filter - combine with existing filters
    if (startDate && endDate) {
      filtered = filtered.filter((log) => {
        const logDate = new Date(log.created_at);
        // Set time to start/end of day for proper comparison
        const start = new Date(startDate);
        start.setHours(0, 0, 0, 0);
        const end = new Date(endDate);
        end.setHours(23, 59, 59, 999);
        return logDate >= start && logDate <= end;
      });
    }

    setFilteredLogs(filtered);
    setCurrentPage(1);
  }, [selectedItems, selectedItems1, selected, startDate, endDate, allLogs]);

  return (
    <section className="lyt-section typ-min-height p-5">
      <div className=" ">
        <div className="d-flex justify-content-between">
          <div
            className="d-flex align-items-center justify-content-between"
            style={{ gap: "10px", width: "100%" }}
          >
            <div
              className="d-flex justify-content-between"
              style={{ gap: "10px", width: "100%" }}
            >
              <div className="d-flex gap-4">
                <div
                  style={{ position: "relative", display: "flex", gap: "8px" }}
                >
                  <div style={{ position: "relative" }}>
                    <button
                      className="btn  shadow-sm d-flex align-items-center justify-content-center"
                      onClick={() => {
                        setShowSearch(!showSearch);
                        // setSearchQuery("");
                      }}
                      style={{
                        minWidth: "40px",
                        height: "33px",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        backgroundColor: "#fff",
                      }}
                    >
                      {showSearch ? (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          fill="black"
                          viewBox="0 0 16 16"
                        >
                          <path d="M4.646 4.646a.5.5 0 011.415 0L8 6.586l1.939-1.94a.5.5 0 01.707.708L8.707 7.293l1.939 1.94a.5.5 0 01-.707.707L8 8.001 6.061 9.94a.5.5 0 11-.707-.707L7.293 8 5.354 6.061a.5.5 0 010-.707z" />
                        </svg>
                      ) : (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          fill="black"
                          viewBox="0 0 16 16"
                        >
                          <path
                            d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0
            1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zm-5.24 1.106a5 5 0 1 1
            0-10 5 5 0 0 1 0 10z"
                          />
                        </svg>
                      )}
                    </button>

                    {showSearch && (
                      <input
                        type="text"
                        placeholder="Search company or branch"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        style={{
                          position: "absolute",
                          top: "45px",
                          left: 0,
                          width: "260px",
                          padding: "8px 10px",
                          border: "1px solid #ccc",
                          borderRadius: "4px",
                          backgroundColor: "#fff",
                          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                          zIndex: 10,
                        }}
                      />
                    )}
                  </div>
                </div>

                {/* <div className="dropdown">
                  <button
                    className="btn btn-light dropdown-toggle w-100"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Select Company Name
                  </button>

                  <ul className="dropdown-menu p-2" style={{ width: "270px" }}>
                    <div className="border p-2 rounded mb-2">
                      <div>
                        {selectedItems.length > 0
                          ? selectedItems.map((item, index) => (
                              <span
                                key={index}
                                className="bg-dark text-white px-1 rounded me-1"
                              >
                                {item}
                              </span>
                            ))
                          : "Select Name"}
                      </div>
                    </div>

                    <li className="">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search"
                        value={search}
                        onChange={(e) => setSearch1(e.target.value)}
                      />
                    </li>

                    <div className="mt-2 w-full">
                      {companies
                        .filter((c) =>
                          c.toLowerCase().includes(search1.toLowerCase())
                        )
                        .map((company) => (
                          <li
                            className="form-check d-flex justify-content-between align-items-center py-1 border-bottom"
                            key={company}
                          >
                            <label className="form-check-label flex-grow-1 fs-6">
                              {company}
                            </label>
                            <input
                              className="form-check-input"
                              type="checkbox"
                              checked={selectedItems.includes(company)}
                              onChange={() => toggleSelection(company)}
                            />
                          </li>
                        ))}
                    </div>
                  </ul>
                </div> */}

                <Dropdown
                  label="Company Name"
                  options={companies}
                  selectedItems={selectedItems}
                  setSelectedItems={setSelectedItems}
                />

                {/* <div className="">
                  <button
                    className="btn btn-light dropdown-toggle w-100"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Select Branch Id
                  </button>

                  <ul className="dropdown-menu p-2" style={{ width: "270px" }}>
                    <div className="border p-2 rounded mb-2">
                      <div>
                        {selectedItems1.length > 0
                          ? selectedItems1.map((item, index) => (
                            <span
                              key={index}
                              className="bg-dark text-white px-1 rounded me-1"
                            >
                              {item}
                            </span>
                          ))
                          : "Select Name"}
                      </div>
                    </div>

                    <li>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search"
                        value={search1}
                        onChange={(e) => setSearch1(e.target.value)}
                      />
                    </li>

                    <div className="mt-2 w-full">
                      {branches
                        .filter((b) =>
                          b.toLowerCase().includes(search1.toLowerCase())
                        )
                        .map((branch) => (
                          <li
                            className="form-check d-flex justify-content-between gap-2 align-items-center py-1 border-bottom"
                            key={branch}
                          >
                            <input
                              className="form-check-input"
                              type="checkbox"
                              checked={selectedItems1.includes(branch)}
                              onChange={() => toggleSelection1(branch)}
                            />
                            <label className="form-check-label flex-grow-1 fs-6">
                              {branch}
                            </label>
                          </li>
                        ))}
                    </div>
                  </ul>
                </div> */}
                <Dropdown
                  label="Branch Name"
                  options={branches}
                  selectedItems={selectedItems1}
                  setSelectedItems={setSelectedItems1}
                />

                <div className="dropdown">
                  <button
                    className="btn dropdown-toggle w-100"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    style={{
                      height: "33px",
                      fontSize: "12px",
                      fontWeight: "500",
                      textAlign: "left",
                      backgroundColor: "#ffffff", // white background
                      border: "1px solid #E4E4E7", // light gray border
                      borderRadius: "6px",
                      color: "#1F1F23", // dark text
                    }}
                    onMouseOver={(e) =>
                      (e.currentTarget.style.backgroundColor = "#ffffff")
                    }
                    onMouseOut={(e) =>
                      (e.currentTarget.style.backgroundColor = "#ffffff")
                    }
                  >
                    {selected}
                  </button>

                  <ul
                    className="dropdown-menu w-100 fs-12"
                    style={{
                      boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                      borderRadius: "6px",
                    }}
                  >
                    {[
                      "All Users",
                      "Compliance Officer",
                      "Auditor",
                      "Approver",
                    ].map((role) => (
                      <li key={role}>
                        <button
                          className="dropdown-item d-flex justify-content-between"
                          style={{
                            padding: "10px",
                            fontSize: "12px",
                            fontWeight: "500",
                            color: "#333",
                          }}
                          onClick={() => {
                            setSelected(role);
                            setCurrentPage(1); // reset to first page on filter
                          }}
                        >
                          {role} {selected === role && "✔️"}
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="position-relative d-inline-block" ref={dateDropdownRef} >
                  {/* <button
                    className="btn btn-light  w-20"
                    type="button"
                    onClick={() => setIsOpen(!isOpen)}
                    aria-expanded={isOpen}
                  >
                    <img
                      src="https://cdn-icons-png.flaticon.com/512/747/747310.png"
                      alt="Calendar Icon"
                      width="16"
                      height="16"
                    />
                    <span> Jan 2025 - Feb 2025</span>
                  </button> */}
                  <button
                    className="btn w-20 d-flex align-items-center gap-2"
                    type="button"
                    onClick={() => setIsOpen(!isOpen)}
                    aria-expanded={isOpen}
                    style={{
                      border: "1px solid #ccc",
                      backgroundColor: "#fff",
                      color: "#000",
                      padding: "6px 12px",
                      borderRadius: "5px",
                      fontSize: "12px"
                    }}
                  >
                    <img
                      src="https://cdn-icons-png.flaticon.com/512/747/747310.png"
                      alt="Calendar Icon"
                      width="16"
                      height="16"
                    />
                    <span className="fs-12">
                      {startDate && endDate
                        ? `${startDate.toLocaleDateString("en-GB", {
                            month: "short",
                            year: "numeric",
                          })} - ${endDate.toLocaleDateString("en-GB", {
                            month: "short",
                            year: "numeric",
                          })}`
                        : selectedRange
                        ? selectedRange
                        : "Select Date Range"}
                    </span>
                  </button>


                  {isOpen && (
                    <div
                      className="position-absolute mt-2 bg-white border shadow"
                      style={{
                        zIndex: 1000,
                        width: selectedRange === "Manual" ? "700px" : "250px",
                        maxWidth: selectedRange === "Manual" ? "min(700px, calc(100vw - 60px))" : "250px",
                        right: 0,
                        overflow: "hidden",
                        maxHeight: "90vh",
                        padding: selectedRange === "Manual" ? "12px" : "12px",
                      }}
                    >
                      <div className="row g-0" style={{ margin: 0 }}>
                        <div className={selectedRange === "Manual" ? "col-md-3" : "col-12"} style={{ padding: 0 }}>
                          <ul className="list-group">
                            <li
                              className={`list-group-item fs-12 ${
                                selectedRange === "Today"
                                  ? "bg-light rounded"
                                  : ""
                              }`}
                              style={{ border: "none", cursor: "pointer" }}
                              onClick={() => handleQuickSelect("Today")}
                            >
                              Today
                            </li>
                            <li
                              className={`list-group-item fs-12 ${
                                selectedRange === "Yesterday"
                                  ? "bg-light rounded"
                                  : ""
                              }`}
                              style={{ border: "none", cursor: "pointer" }}
                              onClick={() => handleQuickSelect("Yesterday")}
                            >
                              Yesterday
                            </li>
                            <li
                              className={`list-group-item fs-12 ${
                                selectedRange === "Last 7 days"
                                  ? "bg-light rounded"
                                  : ""
                              }`}
                              style={{ border: "none", cursor: "pointer" }}
                              onClick={() => handleQuickSelect("Last 7 days")}
                            >
                              Last 7 days
                            </li>
                            <li
                              className={`list-group-item fs-12 ${
                                selectedRange === "Last 30 days"
                                  ? "bg-light rounded"
                                  : ""
                              }`}
                              style={{ border: "none", cursor: "pointer" }}
                              onClick={() => handleQuickSelect("Last 30 days")}
                            >
                              Last 30 days
                            </li>
                            <li
                              className={`list-group-item fs-12 ${
                                selectedRange === "Manual"
                                  ? "bg-light rounded"
                                  : ""
                              }`}
                              style={{ border: "none", cursor: "pointer" }}
                              onClick={() => setSelectedRange("Manual")}
                            >
                              Manual
                            </li>
                            <li
                              className={`list-group-item fs-12 ${
                                !startDate && !endDate
                                  ? "bg-light rounded"
                                  : ""
                              }`}
                              style={{ border: "none", cursor: "pointer" }}
                              onClick={() => {
                                setStartDate(null);
                                setEndDate(null);
                                setSelectedRange("");
                              }}
                            >
                              Clear / All Dates
                            </li>
                          </ul>
                        </div>

                        {selectedRange === "Manual" && (
                          <div className="col-md-9 border-start ps-3" style={{ paddingLeft: "12px", overflow: "auto", maxWidth: "100%" }}>
                            <div className="d-flex justify-content-between mb-2">
                              <h5 className="fs-12 mb-0">
                                {startDate
                                  ? startDate.toLocaleDateString("en-GB", {
                                      month: "long",
                                      year: "numeric",
                                    })
                                  : "Select Start Date"}
                              </h5>
                              <h5 className="fs-12 mb-0">
                                {endDate
                                  ? endDate.toLocaleDateString("en-GB", {
                                      month: "long",
                                      year: "numeric",
                                    })
                                  : "Select End Date"}
                              </h5>
                            </div>
                            <div className="row g-2" style={{ margin: 0 }}>
                              <div className="col-md-6" style={{ padding: "0 4px", maxWidth: "50%" }}>
                                <div style={{ width: "100%", overflow: "hidden" }}>
                                  <DatePicker
                                    selected={startDate}
                                    onChange={(date) => setStartDate(date)}
                                    inline
                                  />
                                </div>
                              </div>
                              <div className="col-md-6" style={{ padding: "0 4px", maxWidth: "50%" }}>
                                <div style={{ width: "100%", overflow: "hidden" }}>
                                  <DatePicker
                                    selected={endDate}
                                    onChange={(date) => setEndDate(date)}
                                    inline
                                  />
                                </div>
                              </div>
                            </div>

                            <div className="mt-3 d-flex justify-content-between align-items-center">
                              <div  style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                              }}
                                id="selected-range"
                                className="btn  "
                              >
                                <span style={{
                                  backgroundColor: "#343a40",
                                  color: "#fff",
                                  padding: "6px 12px",
                                  borderRadius: "6px",
                                  fontSize: "12px",
                                }} id="start-display" className="fs-12">{startDate ? startDate.toLocaleDateString("en-GB") : "--"}</span> →
                                <span  style={{
                                  backgroundColor: "#343a40",
                                  color: "#fff",
                                  padding: "6px 12px",
                                  borderRadius: "6px",
                                  fontSize: "12px",
                                }}  id="end-display" className="fs-12">{endDate ? endDate.toLocaleDateString("en-GB") : "--"}</span>
                              </div>
                              <button
                                className="btn btn-dark fs-12"
                                onClick={handleApplyDateFilter}
                              >
                                Apply
                              </button>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div className="">
                {/* Export Dropdown */}
                <div className="d-flex gap-4 justify-content-end mb-3">
                  <div className="dropdown position-relative" ref={dropdownRef2}>
                    {/* <button
  className="btn d-flex align-items-center gap-2 rounded-2"
  onClick={toggleDropdown}
  style={{
    backgroundColor: "#fff",           
    border: "1px solid #E4E4E7",       
    color: "#1F1F23",                  
    fontWeight: 500,                   
    padding: "6px 14px",            
  }}
>
 Export

</button> */}
                    <button
                      className="btn d-flex align-items-center  gap-1 rounded-2"
                      onClick={toggleDropdown1}
                      style={{
                        backgroundColor: "#fff",
                        border: "1px solid #E4E4E7",
                        color: "#1F1F23",
                        fontWeight: 500,
                        padding: "6px 6px",
                        fontSize: "12px"
                      }}
                    >
                      <img
                        className="fs-12"
                        src={exportIcon}
                        alt="Export Icon"
                        width="16"
                        height="16"
                      />
                      Export
                    </button>

                    {showDropdown1 && (
                      <div
                        className="card shadow-sm position-absolute mt-2 end-0"
                        style={{
                          width: "220px",
                          zIndex: 9999,
                          transform: "translateX(10px)",
                        }}
                      >
                        <div>
                          <label className="bg-light py-1 px-2 w-100 fs-12">
                            Format
                          </label>
                          <div className="btn-group w-100 mt-2 px-2">
                            <button
                              className={`btn ${format === "pdf"
                                ? "btn-dark"
                                : "btn-outline-dark"
                                }`}
                              onClick={() => setFormat("pdf")}
                            >
                              <i className="bi bi-file-earmark-pdf fs-12"></i> PDF
                            </button>
                            <button
                              className={`btn ${format === "excel"
                                ? "btn-dark"
                                : "btn-outline-dark"
                                }`}
                              onClick={() => setFormat("excel")}
                            >
                              <i className="bi bi-file-earmark-excel fs-12"></i> Excel
                            </button>
                          </div>
                        </div>

                        <div className="mt-3">
                          <label className="bg-light py-1 px-2 w-100 fs-12">
                            Period
                          </label>
                          <div className="bg-light mx-2 p-2">
                            {[
                              "Monthly",
                              "Quarterly",
                              "Semi-Annually",
                              "Annually",
                            ].map((p) => (
                              <div
                                key={p}
                                className="d-flex justify-content-between py-1 px-1 rounded hover:bg-secondary-subtle"
                                style={{ cursor: "pointer" }}
                                onClick={() => setPeriod(p)}
                              >
                                <span>{p}</span>
                                <span>{period === p ? "✔" : ""}</span>
                              </div>
                            ))}
                          </div>
                        </div>

                        <div className="d-flex justify-content-end">
                          <button
                            className="btn btn-dark w-50 mt-3 mb-2 mx-2 fs-12"
                            onClick={handleExport}
                          >
                            Export
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-4">
          <div className="">
            <div className="card-body p-0">
              <div className="table-responsive">
                <div className="table-scroll">
                <table className="table table-hover align-middle border mt-0 rounded">
                  <thead className="bg-light text-sm text-nowrap fs-12">
                    <tr>
                      {/* <th>
                        <input type="checkbox" />
                      </th> */}
                      <th>Sr No</th>
                      <th>Company Name</th>
                      <th>Branch ID</th>
                      <th>Date & Time</th>
                      <th>IP Address</th>
                      <th>User Type</th>
                      <th>User Name</th>
                      <th>Activity</th>
                      <th>Delete Action</th>
                    </tr>
                  </thead>
                  <tbody className="fs-12 table-color">
                    {paginatedData.length > 0 ? (
                      paginatedData.map((log, i) => (
                        <tr key={log.id}>
                          {/* <td>
                            <input type="checkbox" />
                          </td> */}
                          <td>{(currentPage - 1) * limit + i + 1}</td>
                          <td>{log.company_name}</td>
                          <td>{log.branch}</td>
                          <td>{new Date(log.created_at).toLocaleString()}</td>
                          <td>{log.ip_address}</td>
                          <td>{log.user_type}</td>
                          <td>
                            <div className="d-flex align-items-center gap-2">
                              <img
                                src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQBvqzyx_zoi6q2c0Gd1XnE7wysD9PGOLe3-A&s"
                                alt="User"
                                style={{
                                  width: "24px",
                                  height: "24px",
                                  borderRadius: "50%",
                                  objectFit: "cover",
                                }}
                              />
                              <span
                                style={{
                                  fontSize: "12px",
                                  color: "#3d3d3d",
                                  fontWeight: "500",
                                }}
                              >
                                {log.user}
                              </span>
                            </div>
                          </td>
                          <td>{log.latest_activity}</td>
                          <td>
                            <a
                              href="#"
                              onClick={async (e) => {
                                e.preventDefault();
                                if (
                                  window.confirm(
                                    "Are you sure you want to delete this log?"
                                  )
                                ) {
                                  try {
                                    const response = await fetch(
                                      `${API_URL}/activity/${log.id}`,
                                      {
                                        method: "DELETE",
                                      }
                                    );
                                    const result = await response.json();

                                    if (response.ok) {
                                      toast.success(
                                        "Activity log deleted successfully"
                                      );
                                      fetchLogs(); // Refresh the list
                                    } else {
                                      toast.error(`Failed: ${result.message}`);
                                    }
                                  } catch (error) {
                                    console.error("Error deleting log:", error);
                                    toast.error(
                                      "Something went wrong while deleting the activity log"
                                    );
                                  }
                                }
                              }}
                            >
                              Delete
                            </a>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td
                          colSpan="9"
                          className="text-center py-4 text-gray-500"
                        >
                          No activity logs found.
                        </td>

                      </tr>
                    )}
                  </tbody>
                </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="d-flex justify-content-between align-items-center mt-4">
        <div>
          <select className="form-select form-select-sm w-auto fs-12" disabled>
            <option>{limit} Per Page</option>
          </select>
        </div>

        <nav>
          <ul className="pagination mb-0 d-flex align-items-center gap-2">
            {/* Previous Button */}
            <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
              <button
                className="page-link text-dark border-0 bg-transparent fs-12"
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
              >
                Previous
              </button>
            </li>

            {/* First Page + Ellipsis if needed */}
            {currentPage > 3 && (
              <>
                <li className="page-item">
                  <button
                    className={`page-link fw-bold rounded-circle border-0 ${currentPage === 1
                      ? "bg-dark text-white rounded-circle"
                      : "bg-transparent text-dark"
                      }`}
                    onClick={() => handlePageChange(1)}
                  >
                    1
                  </button>
                </li>
                <li className="page-item disabled">
                  <span className="page-link text-dark border-0 bg-transparent">
                    ...
                  </span>
                </li>
              </>
            )}

            {/* Dynamic Page Range around current page */}
            {Array.from({ length: totalPages }, (_, i) => i + 1)
              .filter(
                (page) =>
                  page === 1 ||
                  page === totalPages ||
                  (page >= currentPage - 2 && page <= currentPage + 2)
              )
              .map((page) => (
                <li
                  key={page}
                  className={`page-item ${currentPage === page ? "active" : ""
                    }`}
                >
                  <button
                    className={`page-link ${currentPage === page
                      ? "bg-dark text-white fw-bold rounded-circle border-0"
                      : "text-dark border-0 bg-transparent"
                      }`}
                    onClick={() => handlePageChange(page)}
                     style={{
                        width: "36px",
                        height: "36px",
                        padding: 0,
                        lineHeight: "36px",
                        textAlign: "center",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                  >
                    {page}
                  </button>
                </li>
              ))}

            {/* Last Page + Ellipsis if needed */}
            {currentPage < totalPages - 2 && (
              <>
                <li className="page-item disabled">
                  <span className="page-link text-dark border-0 bg-transparent">
                    ...
                  </span>
                </li>
                <li className="page-item">
                  <button
                    className="page-link text-dark border-0 bg-transparent"
                    onClick={() => handlePageChange(totalPages)}
                  >
                    {totalPages}
                  </button>
                </li>
              </>
            )}

            {/* Next Button */}
            <li
              className={`page-item ${currentPage === totalPages ? "disabled" : ""
                }`}
            >
              <button
                className="page-link text-dark border-0 bg-transparent fs-12"
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
              >
                Next
              </button>
            </li>
          </ul>
        </nav>
      </div>
    </section>
  );
}

export default Activity;
